import { StyledStepContentWrapper } from "../steps.styles";

/**
 * An empty UI for steps that do not display anything.
 */
export function Empty(): JSX.Element {
  return <StyledStepContentWrapper></StyledStepContentWrapper>;
}
